import React from 'react';
import ScheduleEditor from './ScheduleEditor';

/**
 * ScheduleCalendarDialog - Wrapper for backward compatibility
 * Now uses the new ScheduleEditor component
 */
const ScheduleCalendarDialog = ({ open, onClose, schedule, playlists, onSave }) => {
    return (
        <ScheduleEditor
            open={open}
            onClose={onClose}
            schedule={schedule}
            playlists={playlists}
            onSave={onSave}
        />
    );
};

export default ScheduleCalendarDialog;
